import axios from "axios";
import { USER_API, getApiHeader } from "./apiConfig";

const parseJsonIfString = (value) => {
  if (typeof value !== "string") return value;
  const trimmed = value.trim();
  if (!trimmed) return value;
  try {
    return JSON.parse(trimmed);
  } catch {
    return value;
  }
};

/** Keep axios `{ data }` as the SAP body so existing callers stay unchanged. */
const unwrapSapProxyAxios = (response) => {
  const body = response?.data;
  if (body && typeof body === "object" && !Array.isArray(body)) {
    if (body.endpoint != null && body.payload != null) {
      return { ...response, data: parseJsonIfString(body.payload) };
    }
  }
  return {
    ...response,
    data: parseJsonIfString(body),
  };
};

/**
 * POST /api/sap/proxy with the app bearer token.
 * Body: { endpoint: "/VendorCreation", payload: { ... } }
 */
export const postSapProxy = (endpoint, payload) => {
  const path = String(endpoint || "").trim();
  const normalized = path.startsWith("/") ? path : `/${path}`;

  return axios
    .post(
      `${USER_API}sap/proxy`,
      { endpoint: normalized, payload: payload ?? {} },
      getApiHeader()
    )
    .then(unwrapSapProxyAxios);
};
